
import { useStore } from '@/store'
import { computed, defineComponent, inject, onUnmounted, ref, watch } from 'vue'
import * as RenderingConstants from '@/constants/rendering-constants'
import RenderingPathService from '@/services/rendering/rendering-path.service'
import bodySettings from '@/settings/body-settings.json'
import threadSettings from '@/settings/thread-settings.json'
import pocketSettings from '@/settings/pocket-settings.json'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'RenderingRandselPocket',
  props: {
    cameraPos: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const emitter: any = inject('emitter')
    const configBodyId = computed(() => store.getters.configBodyId)
    const configThreadId = computed(() => store.getters.configThreadId)
    const configPocketId = computed(() => store.getters.configPocketId)
    let imagePath = ref('')
    let renderPathService = new RenderingPathService()

    emitter.on('updateConfig', updateRendering)

    // prettier-ignore
    watch(() => configBodyId.value, (_) => { updateRendering() })
    // prettier-ignore
    watch(() => configThreadId.value, (_) => { updateRendering() })
    // prettier-ignore
    watch(() => configPocketId.value, (_) => { updateRendering() })

    function updateRendering() {
      try {
        const bodyId = renderPathService.formatConfig(configBodyId.value, bodySettings.fullorderColors)
        const threadId = renderPathService.formatConfig(configThreadId.value, threadSettings.threadColors)
        const pocketId = renderPathService.formatConfig(configPocketId.value, pocketSettings.pocketTextures)
        setRendering(bodyId, threadId, pocketId)
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    function setRendering(bodyId: string | null, threadId: string | null, pocketId: string | null) {
      if (!bodyId || !threadId || !pocketId) {
        if (!bodyId) {
          console.error('cannot find body id for RenderingRandselFront')
        }
        imagePath.value = ''
        return
      }

      const camPath = 'cam' + (props.cameraPos + 1) + '/'
      const optionPath = 'pocket/' + bodyId + '/' + threadId + '/' + pocketId + '.png'
      const path = RenderingConstants.path + camPath + optionPath
      imagePath.value = path
    }

    onUnmounted(() => {
      emitter.off('updateConfig', updateRendering)
    })

    return {
      imagePath
    }
  }
})
